import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from './core/services/auth/auth.service';
import { RouterOutlet } from '@angular/router';
import { skip, take } from 'rxjs';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private destroy = inject(DestroyRef)



  ngOnInit(): void {
    this.route.queryParams.pipe(take(2), skip(1))
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
      next: (params) => {
        if (params['redirect_uri'] && params['client_id']) {
          const authParams = {
            redirect_uri: params['redirect_uri'],
            client_id: params['client_id'],
            code_challenge: params['code_challenge'],
            code_challenge_method: params['code_challenge_method'],
            state: params['state'],
            scope: params['scope'],
            options: params['options'],
          };
          this.authService.setAuthParams(authParams);
        } else {
          console.error('Required query parameters are missing');
        }
      },
      error: (error) => {
        console.error('Error reading query params:', error);
      },
    });
  }
}
